import { AnimatePresence } from "framer-motion";
import { Routes, Route, Navigate } from "react-router-dom";
import Landing from "../pages/landing";
import B4CertificadoPage from "../pages/b4_and_vert_ecotech/CertificadoPage";

const AppRoutes = () => {
  return (
    <AnimatePresence>
      <Routes>
        <Route exact path="/" element={<Landing />} />
        <Route exact path="/preview_b4" element={<Navigate to="/" replace />} />
        <Route exact path="/certificado" element={<B4CertificadoPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AppRoutes;
